





















































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import {  SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTable } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import { currentUserKey } from '@/shared/msw-constants';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { DropdownLight } from '@/shared/dropdown-light';
import { SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import GenericModal from '@/shared/generic-modal/generic-modal.vue';
import TimeZone from './components/time-zone.vue';
import AlertSetting from './components/alert-setting.vue';
import ConfirmEmail from './components/confirm-email.vue';
import RenewalContact from './components/renewal-contact.vue';
import DistributorInfo from './components/distributor-info.vue';
import { ConfirmButton, ConfirmOptions, confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import TaxinfoModal from './components/taxinfo-modal.vue';
import ManageAlternateemail from './components/manage-alternateemail.vue';
import UsedomaincredModal from './components/usedomaincred-modal.vue';
import { SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import RegexValidators from '@/shared/regex-validators';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import EditAddress from './components/edit-address.vue';
import UpdatePassword from './components/update-password.vue';
import { InfoState } from '@/core';
import TwoFactorAuth from './components/two-factor-auth.vue';
import IdpConfigDialog from './components/idp-config-diaog.vue';
import OffTwoFactorAuth from './components/off-two-factor-auth .vue';
import Userlist from './components/userlist.vue';
import UUIFComponent from '@/shared/uuifComponent';
import { helpContentData } from '@/shared/help-content-data/msw-help-data.ts';
import DeleteAccDialog from './components/delete-acc-dialog.vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import EditBasicInfo from './components/edit-basic-info.vue';
import ChangeBillingAddress from './change-billing-address.vue';
import PendoConsentdDialog from '@/shared/pendo-consent-dialog/pendo-consent-dialog.vue';
import * as decode from 'jwt-decode';

const cssPrefix = 'snb-profile';
@Component({
  components: {
    SwTabGroup,
    SwTabPage,
    SwIcon,
    SwTextfield,
    SwButton,
    SwCheckbox,
    SwSelect,
    SwTable,
    SwRadio,
    SwToggle,
    DropdownLight,
    SwDropMenu,
    GenericModal,
    TimeZone,
    SwExpandableTextfield,
    SwContentToolbarExpand,
    AlertSetting,
    ConfirmEmail,
    RenewalContact,
    DistributorInfo,
    TaxinfoModal,
    ManageAlternateemail,
    UsedomaincredModal,
    SwContentToolbar,
    SwIconButton,
    EditAddress,
    UpdatePassword,
    TwoFactorAuth,
    IdpConfigDialog,
    OffTwoFactorAuth,
    Userlist,
    ...UUIFComponent,
    DeleteAccDialog,
    MswAppTitle,
    EditBasicInfo,
    ChangeBillingAddress,
    PendoConsentdDialog,
  },
  directives: {
    tooltip,
  },
})
export default class SnbProfile extends SwExtendedVue {
  isPartner: boolean = false;
  renewalDays: string = '';
  cssPrefix = cssPrefix;
  selectedTabId: string = 'tab1';
  basicTabsProps: TabProps[] = [
    {
      tabId: 'tab1',
      label: this.$t('profile.heading')
      .toString(),
    },
    {
      tabId: 'tab2',
      label: this.$t('profile.sideNavOpt1')
      .toString(),
    },
    {
      tabId: 'tab3',
      label: this.$t('profile.sideNavOpt2')
      .toString(),
    },
  ];
  isIDPHelpModal: boolean =  false;
  helpContent: any = '';
  showUserSearchDataTable : boolean =  false;
  showActivationKeyDetails :boolean = false;
  userPreferenceData : any ;
  optedForSecurityNotification: boolean = false;
  optedForBeta: boolean = false;
  optedForZT: boolean = false;
  displayDistributorInfo : boolean = false;
  displayUseDomainCred : boolean = false;
  displayEditAddress : boolean = false;
  personalInfoObj = {
    firstName : '',
    lastName : '',
    company : '',
    title : '',
    companyAddressline1 : '',
    companyAddressline2 : '',
    companyCity : '',
    companyState : '',
    companyStateName : '',
    companyProvince : '',
    companyPostalCode : '',
    companyCountry : '',
    companyCountryName : '',
    companyPhoneNumber : '',
    personalAddressline1 : '',
    personalAddressline2 : '',
    personalCity : '',
    personalState : '',
    personalStateName : '',
    personalProvince : '',
    personalPostalCode : '',
    personalCountry : '',
    personalCountryName : '',
    personalPhoneNumber : '',
    federatedTaxId : '',
    orgId : '',
    isAdmin : false,
    customerAddrID : '',
    isDenied : false,
    isHighlighter : false,
    oidcRedirectURL : '',
    samlRedirectURL : '',
    isGroupChangeEmail : false,
    idpStatus : '',
    appliancePassword : '',
    isIDPEnabled : false,
    isReadOnly : false,
    readOnlyMode : false,
    optedForIDP : false,
  };
  addressChecked: boolean = true;
  emailAddress: string = '';
  userName: string = '';
  showUserName: boolean = true;
  tfaMode: string = '';
  tfaAuthCode: string = '';
  optedForTFA: boolean = false;
  renewalRows : any[]  = [];
  distryInfoDetails  : any[] = [];
  taxInfoDetails : any[] = [];
  notificationPreferences: any;
  currentTimeZoneId : any = '';
  currentTimePart1 : any = '';
  currentTimePart2 : any = '';
  timeFormat : any = '';
  timeZoneName: string = '';
  federatedUserName : any = '';
  showFederatedOption: boolean = false;
  optedForFederated: boolean = false;
  privacyOption: string = '';
  isExportComplianceApproved:boolean = false;
  submitFlag:boolean = false;
  exportComplianceComments:string = '';
  arrDC: SelectOption[] = [];
  selectedDC = '';
  states: any[];
  showDefaltLandingOptions: boolean = false;
  defaultLandingOptions: SelectOption[] = [];
  defaultLandingPage: string = '';
  isSubscriptionCodeAvailable: boolean = false;
  stopLoadingCounter = 0;
  displayEmailUpdate : boolean = false;
  displayTimeZoneUpdate : boolean = false;
  timeZones : any[] = [];
  displayAlertSetting : boolean = false;
  emailSubscriptionList : any[] = [];
  displayRenewalContact : boolean = false;
  distryList : any[] = [];
  confirmService: any = confirmService;
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  optionsOpt: ConfirmOptions;
  buttonsOpt: ConfirmButton[];
  displayTaxInfoMadal : boolean = false;
  captureATPEmail : any[] = [];
  displayAleternateEmail : boolean = false;
  pwd: string = '';
  emailValidator = new RegExp(RegexValidators.email);
  phoneNoValidator = new RegExp(RegexValidators.phoneNo);
  addressToPass : any = {};
  displayUpdatePassword : boolean = false;
  generatedSecretId: string = '';
  generatedTfaAuthCode: string = '';
  generatedSecretIdDisplay: string = '';
  fidoOptionValue: string = 'NO';
  showFidoOptions: string = 'NO';
  optedForFido: boolean = false;
  username: string = '';
  pass: string = '';
  rePass: string = '';
  fidoAppliancePassword: string = '';
  apiTfaOption:any;
  isAllowTFAOff: boolean = false;
  sendTFAsms: string = '';
  tfaDialogData : any = {};
  displayTfa : boolean = false;
  displayOffTfa : boolean = false;
  renewalEditMode: boolean = false;
  renewalBackUp: string;
  invalidRenewalDays: boolean = false;
  showIdpConfigDialog : boolean = false;
  idpConfigData : any = {};
  selectedChoiceId: string = '';
  showRemoveIdpDialog: boolean = false;
  showDeleteAccDialog: boolean = false;
  editBasicInfoModal: boolean = false;
  basicInfoObj: any = {};
  showFields: any = '';
  optedForAnalytics: boolean = false;
  showPendoAnalytics: boolean = false;
  showPendoConsentModal: boolean = false;

  beforeCreate() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    if (token.hasOwnProperty('orgbased') && token?.orgbased === 'YES') {
      if (this.$route.query && this.$route.query.mode === 'APP') {
        console.warn('navigating back to org profile');
        console.warn('checking route', this.$route.query.mode === 'APP');
        window.parent.postMessage({
          orgUserGoToOrgProfile : true,
        },                        '*');
      } else {
        this.$router.push({ path: '/m/feature/org-profile' });
      }
    }
  }

  created() {
    this.isExportComplianceApproved = false;
    this.submitFlag = false;
    this.exportComplianceComments = '';
    const currentUser : any = localStorage.getItem(currentUserKey);
    this.isPartner = JSON.parse(currentUser).roles
        .includes('Partner');
    // }
    this.stopLoadingCounter = 0;
    this.getUserDetails();
    this.getDCList();
    this.getStateList();
    this.getDefaultLandingPage();
    if (localStorage.getItem('redirectarg1') && localStorage.getItem('redirectarg2')) {
      if (localStorage.getItem('redirectarg1')!.length > 0 && localStorage.getItem('redirectarg2')!.length > 0) {
        const RC = localStorage.getItem('redirectarg1');
          // const RC = params.RC
        const tempToken = localStorage.getItem('redirectarg2')!.trim()
      .replace(/ /g, '+');
      // const tempToken = params.tempToken.trim().replace(/ /g, "+");
        this.$store
      .dispatch('SnbProfileStoreModule/getSubscriptionCode', { code : RC, tempToken1 : tempToken })
      .then((res: any) => {
        // tslint:disable-next-line:max-line-length
        if (res.success === 'MSWAPP:EMPTYPRODLIST' || res.success === 'GEN:UNMATCHEMAILANDSUBCODE' || res.success === 'GEN:INVALIDSUBSCRIPTIONCODE' || res.success === 'MSWAPP:FAILURE' || res.success === 'MSWAPP:DELETEPRODUCTWARNING') {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.message });
          return;
        }
        if (res.success === 'MSWAPP:SUBSCRIPTIONEMAILSENTSUCCESS') {
          this.isSubscriptionCodeAvailable = true;
        } else if (res.success === 'MSWAPP:DELETESUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.message });
          this.$store.dispatch('navigateTo', 'ui/logout');
        }
      });
      }
    }
    this.buttons = [
      { key: 'cancel', name: (this.$t('common.cancel')
      .toString())},
      { key: 'yes', name: (this.$t('profile.yes')
      .toString()), isDefault: true  },
    ];
    this.options = {
      status: 'high',
      title: this.$t('products.confirmation')
      .toString(),
      message: '',
      buttons: this.buttons,
    };
    this.buttonsOpt = [
      { key: 'cancel', name: (this.$t('profile.no')
      .toString())},
      { key: 'yes', name: (this.$t('profile.yes')
      .toString()), isDefault: true  },
    ];
    this.optionsOpt = {
      status: 'informational',
      title: this.$t('products.confirmation')
      .toString(),
      message: '',
      buttons: this.buttonsOpt,
    };
  }

  openIDPHelpModal() {
    this.helpContent = helpContentData?.filter((el: any) => el.helpId === 'external-idp')[0].content;
    this.isIDPHelpModal = true;
  }

  getDefaultLandingPage() {
    this.$store
      .dispatch('SnbProfileStoreModule/getDefaultLandingPage', { countryCode : 'US' })
      .then((res: any) => {
        if (res.msgCode === 'MSWAPP:SUCCESS') {
          this.showDefaltLandingOptions = res.isShowLandingApp;
          if (this.showDefaltLandingOptions) {
            this.defaultLandingOptions = res.content.landingApp.map((each : any) => {
              if (each.isDefault) {
                this.defaultLandingPage = each.landingAppId;
              }
              return {
                id : each.landingAppId,
                label: each.landingAppValue,
                value: each.landingAppValue,
              };
            });
            if (this.defaultLandingPage === '') {
              this.defaultLandingPage = this.defaultLandingOptions[0].id;
            }
          }
        }
        this.stopLoadingCounter += 1;
        if (this.stopLoadingCounter >= 4) {
          this.$store.commit('stopLoading');
        }
      });
  }

  getStateList() {
    this.$store
      .dispatch('MswProductsStoreModule/getStates', { countryCode : 'US' })
      .then((res: any) => {
        console.warn(res);
        this.states = res.map((each: any) => {
          return {
            id: each.stateCode,
            label: this.$t(each.stateName),
            value: each.stateCode,
          };
        });
        this.stopLoadingCounter += 1;
        if (this.stopLoadingCounter >= 4) {
          this.$store.commit('stopLoading');
        }
      });
  }

  getDCList() {
    this.$store.dispatch('SnbProfileStoreModule/getDCList', this.$store.getters.getUserId)
    .then((resp) => {
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        this.arrDC = [];
        resp.content.dataCenterDetails.forEach((ele : any) => {
          this.arrDC.push({
            id : ele.dcid,
            value : ele.dcvalue,
            label : ele.dcvalue,
          });
        });
        this.selectedDC = resp.content.ChoosenDC;
        this.stopLoadingCounter += 1;
        if (this.stopLoadingCounter >= 4) {
          this.$store.commit('stopLoading');
        }
      }
    });
  }

  getUserDetails() {
    this.getPreferenceDetails();
    this.$store.commit('startLoading');
    Promise.all([
      this.$store.dispatch('SnbProfileStoreModule/getUserDetails', this.$store.getters.getUserId),
      // this.$store.dispatch('SnbProfileStoreModule/getCheckRights'),
    ])
      .then((resp: any) => {
        console.warn(resp);
        this.showFidoOptions = resp[0].content.showFidoOptions;
        this.fidoOptionValue = resp[0].content.fidoOptionValue;
        this.fidoAppliancePassword = resp[0].content.appliancePassword;
        this.apiTfaOption = resp[0].content.tfaOption;
        this.isAllowTFAOff = resp[0]?.content?.isAllowTFAOff === 'YES';
        this.sendTFAsms = resp[0].content.sendTFAsms;
        this.personalInfoObj.firstName = resp[0].content.firstName;
        this.personalInfoObj.lastName = resp[0].content.lastName;
        this.personalInfoObj.company = resp[0].content.companyName;
        this.personalInfoObj.title = resp[0].content.title;
        this.personalInfoObj.companyAddressline1 = resp[0].content.companyAddress;
        this.personalInfoObj.companyAddressline2 = resp[0].content.companyAddress1;
        this.personalInfoObj.companyCity = resp[0].content.companyCity;
        this.personalInfoObj.companyState = resp[0].content.companyState;
        this.personalInfoObj.companyStateName = resp[0].content.companyStateName;
        this.personalInfoObj.companyProvince = resp[0].content.companyProvince;
        this.personalInfoObj.companyPostalCode = resp[0].content.companyZipCode;
        this.personalInfoObj.companyCountry = resp[0].content.companyCountry;
        this.personalInfoObj.companyCountryName = resp[0].content.companyCountryName;
        this.personalInfoObj.companyPhoneNumber = resp[0].content.companyPhone;
        this.personalInfoObj.personalAddressline1 = resp[0].content.personalAddress;
        this.personalInfoObj.personalAddressline2 = resp[0].content.personalAddress1;
        this.personalInfoObj.personalCity = resp[0].content.personalCity;
        this.personalInfoObj.personalState = resp[0].content.personalState;
        this.personalInfoObj.personalStateName = resp[0].content.personalStateName;
        this.personalInfoObj.personalProvince = resp[0].content.personalProvince;
        this.personalInfoObj.personalPostalCode = resp[0].content.personalZipCode;
        this.personalInfoObj.personalCountry = resp[0].content.personalCountry;
        this.personalInfoObj.personalCountryName = resp[0].content.personalCountryName;
        this.personalInfoObj.personalPhoneNumber = resp[0].content.personalPhone;
        this.personalInfoObj.federatedTaxId = resp[0].content.fedratedTaxId;
        this.personalInfoObj.orgId = resp[0].content.orgId;
        this.personalInfoObj.isAdmin = resp[0].content.isAdmin;
        this.personalInfoObj.customerAddrID = resp[0].content.customerAddressId;
        this.personalInfoObj.isDenied = resp[0].content.isDeniedUser;
        this.personalInfoObj.isHighlighter = resp[0].content.isHighLighter;
        this.personalInfoObj.oidcRedirectURL = resp[0].content.IDPOIDCRedirectURL;
        // this.personalInfoObj.oidcRedirectURL = 'https://10.5.50.121/muir/login';
        this.personalInfoObj.samlRedirectURL = resp[0].content.IDPSAMLRedirectURL;
        // this.personalInfoObj.samlRedirectURL = 'https://10.5.50.120/api/extaut';
        this.personalInfoObj.isGroupChangeEmail = resp[0].content.isGroupChangeEmail;
        this.personalInfoObj.idpStatus = resp[0].content.IDPStatus;
        this.personalInfoObj.appliancePassword = resp[0].content.appliancePassword;
        // this.personalInfoObj.appliancePassword = 'YHMCOXCT';
        this.personalInfoObj.isIDPEnabled = resp[0].content.isIDPEnabled === 'YES' || resp[0].content.isIDPEnabled === 'READONLY';
        this.personalInfoObj.isReadOnly = resp[0].content.isIDPEnabled === 'READONLY';
        this.personalInfoObj.optedForIDP = this.personalInfoObj.idpStatus === 'YES';
        this.personalInfoObj.readOnlyMode = this.personalInfoObj.isReadOnly && this.personalInfoObj.idpStatus === 'YES';
        // if (this.$store.getters.getIsSanboxLoggedIn && this.personalInfoObj.isDenied) {
        //   const rights = resp[1].content.sections;
        //   for (let i = 0; i < rights.length; i += 1) {
        //     if (rights[i].taskname === 'USERPROFILEASPX-EXPORTAPPROVALSECTION') {
        //       this.complianceApprovalSection = true;
        //       break;
        //     }
        //   }
        // }
        if (resp[0].content.companyAddressFlag !== '1') {
          this.addressChecked = false;
        }
        this.showPendoAnalytics = resp[0]?.content?.showPendo !== '' || false;
        if (resp[0]?.content?.showPendo !== '' && resp[0]?.content?.showPendo !== 'NO_CHOICE') {
          this.optedForAnalytics = resp[0]?.content?.showPendo === 'YES' ? true : false;
        }
        // Account Tile
        this.emailAddress = resp[0].content.emailAddress;
        this.userName = resp[0].content.userName;
        if (this.userName.match(/(4_|5_)/)) {
          this.showUserName = false;
        }
        this.tfaMode = resp[0].content.tfaOption;
        this.tfaAuthCode = resp[0].content.tfaAuthCode;
        if (resp[0].content.tfaOption !== 'OFF' && resp[0].content.tfaOption !== '') {
          this.optedForTFA = true;
        }
        if (resp[0].content.renewalContact) {
          this.renewalRows = resp[0].content.renewalContact;
        }
        // Distributor Info
        if (resp[0].content.partnerOrg) {
          this.distryInfoDetails = resp[0].content.partnerOrg;
        }
        // Tax Info
        if (resp[0].content.partnerCertificate) {
          this.taxInfoDetails = resp[0].content.partnerCertificate;
        }
        this.notificationPreferences = resp[0].content.notificationPref;
        this.currentTimeZoneId = resp[0].content.timeZoneId;
        const currentTime = resp[0].content.currnettimeZone.split(' ');
        this.currentTimePart1 = currentTime[0];
        this.currentTimePart2 = currentTime[1].toLowerCase();
        this.timeFormat = resp[0].content.timeZoneFormat;
        this.timeZoneName = resp[0].content.timeZoneName;
        this.federatedUserName = resp[0].content.federatedUserName;
        if (this.$store.getters.isFederatedEmail(this.emailAddress.split('@')[1])) {
          this.showFederatedOption = true;
          if (this.federatedUserName !== '') {
            this.optedForFederated = true;
          }
        }
        this.privacyOption = resp[0].content.privacyOption;
        this.$store.commit('stopLoading');
        this.stopLoadingCounter += 1;
        if (this.stopLoadingCounter >= 4) {
          this.$store.commit('stopLoading');
        }
      });
  }

  getPreferenceDetails() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getPreferenceDetails')
      .then((resp) => {
        console.warn(resp);
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.userPreferenceData = resp.content;
          this.renewalDays = this.userPreferenceData.renewalDays;
          if (this.userPreferenceData.privacy === '1') {
            this.optedForSecurityNotification = false;
          } else {
            this.optedForSecurityNotification = true;
          }
          if (this.userPreferenceData.betaTester === '0') {
            this.optedForBeta = false;
          } else {
            this.optedForBeta = true;
          }
        }
        // ZT Value
        if (this.userPreferenceData.isZTEnabled === '1') {
          this.optedForZT = true;
        }
        this.stopLoadingCounter += 1;
        if (this.stopLoadingCounter >= 4) {
          this.$store.commit('stopLoading');
        }
      });
  }

  offTwoFactorCloseModal(status: any) {
    this.displayOffTfa = false;
    this.optedForTFA = status;
  }

  closeIdpConfigDialog() {
    this.showIdpConfigDialog = false;
    this.getUserDetails();
  }

  closeRemoveIdpDialog() {
    this.showRemoveIdpDialog = false;
    this.getUserDetails();
  }

  closeNewPasswordDialog() {
    this.getUserDetails();
  }

  onSelectTab(tabId: string) {
    if (tabId === 'tab1') {
      this.showUserSearchDataTable = false;
      this.showActivationKeyDetails = false;
    } else if (tabId === 'tab2') {
      this.showActivationKeyDetails = false;
    } else if (tabId === 'tab3') {
      this.showUserSearchDataTable = false;
    } else if (tabId === 'tab4') {
      this.showUserSearchDataTable = false;
      this.showActivationKeyDetails = false;
    }
    this.selectedTabId = tabId;
  }

  dummy() {
    console.warn('setisas');
  }

  onClickBasicButton() {
    console.warn('dedmasa');
  }

  makeEditable() {
    console.warn('editable');
    this.renewalEditMode = true;
  }

  editRename() {
    if (!this.editBasicInfoModal) {
      this.basicInfoObj.firstName = this.personalInfoObj.firstName;
      this.basicInfoObj.lastName = this.personalInfoObj.lastName;
      this.basicInfoObj.title = this.personalInfoObj.title;
      this.basicInfoObj.companyName = this.personalInfoObj.company;
      this.editBasicInfoModal = true;
    }
    this.showFields = 'all';
  }

  updateEmail() {
    this.displayEmailUpdate = true;
  }

  editTimeZone() {
    this.displayTimeZoneUpdate = false;
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getTimeZones')
      .then((resp) => {
        this.$store.commit('stopLoading');
        console.warn(resp);
        this.timeZones = resp.content.timezone;
        this.displayTimeZoneUpdate = true;
        console.warn(this.timeZones);
      });
  }

  alertSettingModal() {
    this.displayAlertSetting = false;
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getEmailSubscription')
      .then((resp) => {
        this.emailSubscriptionList = resp.content.EmailSubscriptionList;
        this.$store.commit('stopLoading');
        this.displayAlertSetting = true;
        console.warn(resp);
      });
  }

  updateBetaSettings() {
    let betaTester = '0';
    if (this.optedForBeta) {
      betaTester = '1';
    }
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/updateBetaSettings', betaTester)
      .then((resp) => {
        console.warn(resp);
        if (resp.operationStatus === 'OK') {
          this.getPreferenceDetails();
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      });
  }

  emailUpdateApiCall(request : any) {
    localStorage.setItem('useMSWToken', 'true');
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/updateEmail', request)
      .then((resp) => {
        this.$store.commit('stopLoading');
        localStorage.removeItem('useMSWToken');
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.displayEmailUpdate = false;
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      });
  }

  renewalContactUpdate(request : any) {
    this.displayRenewalContact = false;
    this.renewalRows.push(request.renewalcontact);
    this.getUserDetails();
    this.$store.commit('stopLoading');
  }

  renewalContactUpdateFailed(resp :  any) {
    this.displayRenewalContact = false;
    this.$store.commit('stopLoading');
    this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
  }

  deleteDistributor(index : any) {
    this.options.message = `Are you sure you want to delete this Distributor Info ${this.distryInfoDetails[index].customerNumber} ?`;
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        const request = {
          distyOrgId : this.distryInfoDetails[index].distyOrgId,
          customerNumber : this.distryInfoDetails[index].customerNumber,
          PartnerOrgId : this.distryInfoDetails[index].partnerOrgId,
        };
        this.$store.commit('startLoading');
        this.$store.dispatch('SnbProfileStoreModule/removeDistryInfo', request)
        .then((resp : any) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.distryInfoDetails.splice(index, 1);
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          }
        });
      }
    });
  }

  openDistributorModal() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getDistributorList', this.emailAddress)
      .then((resp) => {
        if (resp.msgCode === 'MSWAPP:EMPTYPRODLIST') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.distryList = [];
          this.$store.commit('stopLoading');
          return;
        }
        this.$store.commit('stopLoading');
        this.distryList = resp.content.disty;
        this.displayDistributorInfo = true;
      });
  }

  successOnDistributor(request : any) {
    this.distryInfoDetails.push(request);
    this.displayDistributorInfo = false;
  }

  addTaxInfoEntry(request : any) {
    this.taxInfoDetails.push(request);
  }

  deleteTaxInfo(index : any) {
    console.warn(this.taxInfoDetails);
    console.warn(this.states);
    const stateObj =  this.states.filter((item : any) => item.id === this.taxInfoDetails[index].stateCode.trim())[0];
    console.warn(stateObj);
    let stateCode;
    if (stateObj !== undefined) {
      stateCode =  stateObj.id;
      const request = {
        state : stateCode,
        certId : this.taxInfoDetails[index].certificateId,
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('SnbProfileStoreModule/deleteTaxInfo', request)
      .then((resp) => {
        if (resp.operationStatus === 'OK') {
          this.taxInfoDetails.splice(index, 1);
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
        this.$store.commit('stopLoading');
      });
    }
  }

  manageAlternateEmail() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getAlternateEmailData')
    .then((resp) => {
      console.warn(resp);
      this.captureATPEmail = resp.content.captureATPEmail;
      this.$store.commit('stopLoading');
      this.displayAleternateEmail = true;
    });
  }

  updateDefaultLanding() {
    const template = {
      appName: this.defaultLandingPage,
    };
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/updateDefaultLanding', template)
    .then((resp) => {
      if (resp.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
      this.$store.commit('stopLoading');
    });
  }

  updateUserDetails() {
    let betaTester1 = '0';
    let companyAddressFlag2 = '0';
    let userDetails;
    if (this.optedForBeta) {
      betaTester1 = '1';
    }
    if (this.addressChecked) {
      companyAddressFlag2 = '1';
    }
    if (this.isExportComplianceApproved && this.exportComplianceComments !== '' && this.submitFlag) {
      // this.complianceApprovalSection = false;
      userDetails = {
        emailAddress: this.emailAddress,
        firstName: this.personalInfoObj.firstName,
        lastName: this.personalInfoObj.lastName,
        title: this.personalInfoObj.title,
        companyName: this.personalInfoObj.company,
        companyAddress: this.personalInfoObj.companyAddressline1,
        companyAddress1: this.personalInfoObj.companyAddressline2,
        companyCity: this.personalInfoObj.companyCity,
        companyCountry: this.personalInfoObj.companyCountry,
        companyState: this.personalInfoObj.companyState,
        companyZipCode: this.personalInfoObj.companyPostalCode,
        companyPhone: this.personalInfoObj.companyPhoneNumber,
        betaTester: betaTester1,
        privacyOption: this.privacyOption,
        companyProvince: this.personalInfoObj.companyProvince,
        companyAddressFlag: companyAddressFlag2,
        personalAddress: this.personalInfoObj.personalAddressline1,
        personalAddress1: this.personalInfoObj.personalAddressline2,
        personalPhone: this.personalInfoObj.personalPhoneNumber,
        personalCity: this.personalInfoObj.personalCity,
        personalState: this.personalInfoObj.personalState,
        personalZipcode: this.personalInfoObj.personalPostalCode,
        personalCountry: this.personalInfoObj.personalCountry,
        personalProvince: this.personalInfoObj.personalProvince,
        sourceName: 'MSW',
        federatedUserName: this.federatedUserName,
        pwd: this.pwd,
        tfaMode: this.tfaMode.toUpperCase(),
        tfaAuthCode: this.tfaAuthCode,
        isZeroTouchEnabled: this.optedForZT,
        dcChoiceId: this.selectedDC === '' ? '0' : this.selectedDC,
        exportComplianceComments: this.exportComplianceComments,
        isExportComplianceApproved: this.isExportComplianceApproved,
      };
    } else {
      userDetails = {
        emailAddress: this.emailAddress,
        firstName: this.personalInfoObj.firstName,
        lastName: this.personalInfoObj.lastName,
        title: this.personalInfoObj.title,
        companyName: this.personalInfoObj.company,
        companyAddress: this.personalInfoObj.companyAddressline1,
        companyAddress1: this.personalInfoObj.companyAddressline2,
        companyCity: this.personalInfoObj.companyCity,
        companyCountry: this.personalInfoObj.companyCountry,
        companyState: this.personalInfoObj.companyState,
        companyZipCode: this.personalInfoObj.companyPostalCode,
        companyPhone: this.personalInfoObj.companyPhoneNumber,
        betaTester: betaTester1,
        privacyOption: this.privacyOption,
        companyProvince: this.personalInfoObj.companyProvince,
        companyAddressFlag: companyAddressFlag2,
        personalAddress: this.personalInfoObj.personalAddressline1,
        personalAddress1: this.personalInfoObj.personalAddressline2,
        personalPhone: this.personalInfoObj.personalPhoneNumber,
        personalCity: this.personalInfoObj.personalCity,
        personalState: this.personalInfoObj.personalState,
        personalZipcode: this.personalInfoObj.personalPostalCode,
        personalCountry: this.personalInfoObj.personalCountry,
        personalProvince: this.personalInfoObj.personalProvince,
        sourceName: 'MSW',
        federatedUserName: this.federatedUserName,
        pwd: this.pwd,
        tfaMode: this.tfaMode.toUpperCase(),
        tfaAuthCode: this.tfaAuthCode,
        isZeroTouchEnabled: this.optedForZT,
        dcChoiceId: this.selectedDC === '' ? '0' : this.selectedDC,
      };
    }
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/updateUserDetails', userDetails)
    .then((resp) => {
      if (resp.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
      this.$store.commit('stopLoading');
    });
  }

  onSecurityNotifyChange() {
    const request = {
      betaTester: this.userPreferenceData.betaTester,
      privacy: '0',
      renewalDays: this.userPreferenceData.renewalDays,
    };
    if (this.userPreferenceData.privacy === '0') {
      // tslint:disable-next-line:max-line-length
      this.optionsOpt.message = 'I do not want to receive Security Renewal Notifications and am aware of the potential security risks involved with that election.';
      confirmService.confirm(this.optionsOpt)
      .then((key) => {
        if (key === 'yes') {
          this.optedForSecurityNotification = false;
          this.userPreferenceData.privacy = '1';
          request.privacy = '1';
          this.setPreferenceDetails(request);
        } else {
          this.optedForSecurityNotification = true;
        }
      });
    } else {
      this.optedForSecurityNotification = true;
      this.userPreferenceData.privacy = '0';
      this.setPreferenceDetails(request);
    }
  }

  setPreferenceDetails(request : any) {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/setPreferenceDetails', request)
          .then((resp) => {
            if (resp.operationStatus === 'OK') {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
            }
            this.$store.commit('stopLoading');
          });
  }

  onFederatedPrefChange() {
    if (this.optedForFederated) {
      this.displayUseDomainCred = true;
    }
  }

  showSuccessMessage(msg : any) {
    this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: msg });
  }

  editAddress() {
    const companyAddressParams = {
      company: this.personalInfoObj.company,
      companyAddressline1: this.personalInfoObj.companyAddressline1,
      companyAddressline2: this.personalInfoObj.companyAddressline2,
      companyCity: this.personalInfoObj.companyCity,
      companyProvince: this.personalInfoObj.companyProvince,
      companyPostalCode: this.personalInfoObj.companyPostalCode,
      companyCountry: this.personalInfoObj.companyCountry,
      companyState: this.personalInfoObj.companyState,
      companyPhoneNumber: this.personalInfoObj.companyPhoneNumber,
      isAdmin: this.personalInfoObj.isAdmin,
    };
    const personalAddressParams = {
      firstName: this.personalInfoObj.firstName,
      lastName: this.personalInfoObj.lastName,
      title: this.personalInfoObj.title,
      personalAddressline1: this.personalInfoObj.personalAddressline1,
      personalAddressline2: this.personalInfoObj.personalAddressline2,
      personalCity: this.personalInfoObj.personalCity,
      personalProvince: this.personalInfoObj.personalProvince,
      personalPostalCode: this.personalInfoObj.personalPostalCode,
      personalCountry: this.personalInfoObj.personalCountry,
      personalState: this.personalInfoObj.personalState,
      personalPhoneNumber: this.personalInfoObj.personalPhoneNumber,
    };
    this.addressToPass = {
      companyAddress: companyAddressParams,
      personalAddress: personalAddressParams,
      useCompanyAsPersonal: this.addressChecked,
    };
    console.warn(this.addressToPass);
    this.displayEditAddress = true;
    this.showFields = 'all';
  }

  updateUserAddressDetail(result : any) {
    this.displayEditAddress = false;
    this.personalInfoObj.firstName = result.firstName;
    this.personalInfoObj.lastName = result.lastName;
    this.personalInfoObj.title = result.title;
    this.personalInfoObj.company = result.companyName;
    this.personalInfoObj.companyAddressline1 = result.companyAddress;
    this.personalInfoObj.companyAddressline2 = result.companyAddress1;
    this.personalInfoObj.companyCity = result.companyCity;
    this.personalInfoObj.companyCountry = result.companyCountry;
    this.personalInfoObj.companyCountryName = result.companyCountryName;
    this.personalInfoObj.companyState = result.companyState;
    this.personalInfoObj.companyStateName = result.companyStateName;
    this.personalInfoObj.companyPostalCode = result.companyZipCode;
    this.personalInfoObj.companyPhoneNumber = result.companyPhone;
    this.personalInfoObj.companyProvince = result.companyProvince;
    this.addressChecked = result.companyAddressFlag;
    this.personalInfoObj.personalAddressline1 = result.personalAddress;
    this.personalInfoObj.personalAddressline2 = result.personalAddress1;
    this.personalInfoObj.personalPhoneNumber = result.personalPhone;
    this.personalInfoObj.personalCity = result.personalCity;
    this.personalInfoObj.personalState = result.personalState;
    this.personalInfoObj.personalStateName = result.personalStateName;
    this.personalInfoObj.personalPostalCode = result.personalZipCode;
    this.personalInfoObj.personalCountry = result.personalCountry;
    this.personalInfoObj.personalCountryName = result.personalCountryName;
    this.personalInfoObj.personalProvince = result.personalProvince;
    console.warn(this.personalInfoObj);
    this.updateUserDetails();
  }

  onChangePwd() {
    this.displayUpdatePassword = true;
  }

  deleteUser() {
    this.showDeleteAccDialog = true;
    // const tempToken = localStorage.getItem('redirectarg3');
    // localStorage.removeItem('redirectarg3');
    // this.$store.dispatch('SnbProfileStoreModule/getSubscriptionCode', { tempToken1 : tempToken, code : '' })
    // .then((response : any) => {
    //   this.$store.commit('stopLoading');
    //   // tslint:disable-next-line:max-line-length
    //   if (response.success === 'MSWAPP:EMPTYPRODLIST' || response.success === 'GEN:UNMATCHEMAILANDSUBCODE'
        // || response.success === 'GEN:INVALIDSUBSCRIPTIONCODE' || response.success === 'MSWAPP:FAILURE'
        // || response.success === 'MSWAPP:DELETEPRODUCTWARNING') {
    //     const message : InfoState = { infoMsg : response.msgDesc, infoType: 'failed' };
    //     this.$store.commit('enqueueMessage', message);
    //     return;
    //   }
    //   if (response.success === 'MSWAPP:SUBSCRIPTIONEMAILSENTSUCCESS') {
    //     const message : InfoState = { infoMsg : response.msgDesc, infoType: 'Success' };
    //     this.$store.commit('enqueueMessage', message);
    //   } else if (response.success === 'MSWAPP:DELETESUCCESS') {
    //     const message : InfoState = { infoMsg : response.msgDesc, infoType: 'Success' };
    //     this.$store.commit('enqueueMessage', message);
    //     this.$router.push({ path : '/m/login/login-view' });
    //   }
    // });
  }

  onTfaPrefChange() {
    this.tfaDialogData = {
      twoFactorAuthSecret: `otpauth://totp/MySonicWall:${this.emailAddress}?secret=${this.generateId()}&issuer=MySonicWall`,
      generatedSecretIdDisplay: this.generatedSecretIdDisplay,
      generatedSecretId: this.generatedSecretId,
      tfaAuthCode: this.generatedTfaAuthCode,
      sendTFAsms: this.sendTFAsms,
      personalPhoneNumber: this.personalInfoObj.personalPhoneNumber,
      companyPhoneNumber: this.personalInfoObj.companyPhoneNumber,
      mode: this.tfaMode,
      isAllowTFAOff: this.isAllowTFAOff,
    };
    this.displayTfa = true;
  }

  generateId() {
    const base32 = require('hi-base32');
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 10; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    this.generatedSecretId = base32.encode(text);

    this.generatedTfaAuthCode = text;
    const chunks = [];
    for (let i = 0, charsLength = this.generatedSecretId.length; i < charsLength; i += 4) {
      chunks.push(this.generatedSecretId.substring(i, i + 4));
    }
    this.generatedSecretIdDisplay = chunks.join('-');
    return this.generatedSecretId;
  }

  dataFromTfa(result : any) {
    this.displayTfa = false;
    console.warn(result);
    if (result != null && result === 'closed') {
      this.optedForTFA = false;
      return;
    }
    if (result != null && result === 'close') {
      this.optedForTFA = false;
      return;
    }
    if (result != null && result.code === 'PHONE') {
      this.tfaMode = result.code;
      this.optedForTFA = true;
      return;
    }
    if (result != null && result.code === 'APP') {
      this.optedForTFA = result.verified;
      this.tfaMode = result.tfaMode;
      this.tfaAuthCode = result.tfaAuthCode;
      this.updateTFAPref();
      return;
    }
    if (result !== null && result.tfaMode === 'OFF') {
      this.optedForTFA = false;
      this.tfaAuthCode = result.tfaAuthCode;
      this.tfaMode = result.tfaMode;
      this.updateTFAPref();
      return;
    }
    if (result != null) {
      this.tfaAuthCode = result.tfaAuthCode;
      this.tfaMode = result.tfaMode;
      this.optedForTFA = true;
      this.updateTFAPref();
    } else {
      this.optedForTFA = false;
    }
  }

  closeDialog() {
    this.optedForTFA = false;
    this.displayTfa = false;
  }

  updateTFAPref() {
    const body: any = {
      tfaMode: this.tfaMode,
      tfaAuthCode: this.tfaAuthCode,
    };
    if (!this.optedForTFA) {
      body.isOverRide = 'NO';
    }
    this.$store.dispatch('SnbProfileStoreModule/setTFAPreference', body)
    .then((resp : any) => {
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'success' };
        this.$store.commit('enqueueMessage', message);
      } else if (resp.msgCode === 'MSWAPP:TFAEMAILSENT') {
        const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'success' };
        this.$store.commit('enqueueMessage', message);
        this.displayOffTfa = true;
      } else {
        this.optedForTFA = !this.optedForTFA;
        const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'failed' };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    });
  }

  updateRenewalDays() {
    if (this.invalidRenewalDays) {
      const message : InfoState = { infoMsg : 'Invalid Input.', infoType: 'failed' };
      this.$store.commit('enqueueMessage', message);
      return;
    }
    const template = {
      renewalDays: this.userPreferenceData.renewalDays,
    };
    console.warn(this.invalidRenewalDays);
    this.$store.dispatch('SnbProfileStoreModule/updateRenewalDays', template)
    .then((resp : any) => {
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'success' };
        this.$store.commit('enqueueMessage', message);
        this.renewalBackUp = this.renewalDays;
        this.renewalEditMode = false;
      } else {
        const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'failed' };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    });
  }

  closeRenewal() {
    this.renewalEditMode = false;
    this.renewalDays = this.renewalBackUp;
    // validateRenewalDays();
  }

  validateRenewalDays() {
    this.invalidRenewalDays = false;
    this.userPreferenceData.renewalDays = this.renewalDays;
    if (isNaN(this.userPreferenceData.renewalDays) || !Number.isInteger(parseFloat(this.userPreferenceData.renewalDays)) ||
      this.userPreferenceData.renewalDays < 60 || this.userPreferenceData.renewalDays > 365) {
      this.invalidRenewalDays = true;
    }
  }

  // tslint:disable
  onIDPPrefChange(infoIcon: any = false) {
    if (this.personalInfoObj.optedForIDP && !this.personalInfoObj.isReadOnly) {
      const data = {
        infoIcon,
        oidcRedirectURL: this.personalInfoObj.oidcRedirectURL,
        samlRedirectURL: this.personalInfoObj.samlRedirectURL,
        appliancePassword: this.personalInfoObj.appliancePassword,
        idpStatus: this.personalInfoObj.optedForIDP,
        isReadOnly: this.personalInfoObj.isReadOnly,
      };
      this.idpConfigData = data;
      this.showIdpConfigDialog = true;
    } else if (this.personalInfoObj.isReadOnly) {
      if (infoIcon) {
        const data = {
          infoIcon,
          oidcRedirectURL: this.personalInfoObj.oidcRedirectURL,
          samlRedirectURL: this.personalInfoObj.samlRedirectURL,
          appliancePassword: this.personalInfoObj.appliancePassword,
          idpStatus: this.personalInfoObj.optedForIDP,
          isReadOnly: this.personalInfoObj.isReadOnly,
        };
        this.idpConfigData = data;
        this.showIdpConfigDialog = true;
      } else {
        const msg = 'You cannot change the External IDP set up provided by your organization. Please contact your organization IT for any issues on this.';
        const message : InfoState = { infoMsg : msg, infoType: 'failed' };
        this.$store.commit('enqueueMessage', message);
        this.getUserDetails();
      }
    }
    if (!this.personalInfoObj.optedForIDP) {
      this.showRemoveIdpDialog = true;
    }
  }

  deleteRenewalContact(ind : any) {
    this.buttons = [
        { key: 'cancel', name: 'Cancel', isDefault: true },
        { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'high',
      title: 'Confirmation',
      message: `Are you sure you want to delete this renewal contact i.e ${this.renewalRows[ind].firstName} ${this.renewalRows[ind].lastName} ${this.renewalRows[ind].emailAddress} ? `,
      buttons: this.buttons,
    };
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        this.$store
      .dispatch('SnbProfileStoreModule/deleteRenewalContact', { contactId: this.renewalRows[ind].contactId })
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.renewalRows.splice(ind, 1);
          this.getUserDetails();
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
      });
      }
    });
  }

  onCloseAlertSettings(params:boolean) {
    this.displayAlertSetting = false;
    if(params) {
      this.getUserDetails();
    }
  }

  onCloseTimeZone(params:any) {
    this.displayTimeZoneUpdate = false;
    if (params.refresh === true) {
      this.timeZoneName = params.name;
      this.timeFormat = params.timeFormat;
      this.currentTimePart1 = params.currentTimePart1;
      this.currentTimePart2 = params.currentTimePart2;
      this.getUserDetails();
    }
  }

  onCloseBasicInfo(params:any) {
    this.editBasicInfoModal = false;
    console.warn(params);
    if(params.refresh === true) {
      // this.personalInfoObj.firstName = params.updatedBasicInfo.firstName;
      // this.personalInfoObj.lastName = params.updatedBasicInfo.lastName;
      // this.personalInfoObj.title = params.updatedBasicInfo.title;
      // this.personalInfoObj.company = params.updatedBasicInfo.companyName;
      this.getUserDetails();
    }
  }

  onAnalyticsPrefChange() {
    if (this.optedForAnalytics) {
      this.showPendoConsentModal = true;
    } else {
      this.disablePendoAnalytics()
    }
  }
  /* tslint:disable-next-line */
  async closePendoConsentdDialog(dialogResp: boolean) {
    this.showPendoConsentModal = false;
    if (!dialogResp) {
      this.optedForAnalytics = false;
    }
  }

  disablePendoAnalytics() {
    const params = {
      highlighterNeeded : 'NO',
      mode : 'PENDOENABLE',
    };
    this.$store.dispatch('SwQsgStoreStateModule/postDisableQsg', params)
    .then((result) => { // tslint:disable-line
      if (result.msgCode === 'MSWAPP:SUCCESS') {
        this.showPendoConsentModal = false;
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: result.msgDesc });
        (localStorage as any).setItem('showPendo', 'NO');
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: result.msgDesc });
      }
    })
    .catch(() => {
      (localStorage as any).setItem('enablePendo', false);
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Error' });
    })
    .finally(()=> {
      this.$store.commit('stopLoading');
    });
  }
}
